<script>
import medicalServicesOverrideService from "@/services/medical-services-override";

export default {
  name: "ModalServiceOverride",
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    selectedService: {
      type: Object,
      default: null,
    },
    doctor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      modalData: {
        priceOverride: null,
        enabled: true,
      },
      isSaving: false,
    };
  },
  watch: {
    selectedService: {
      handler(newService) {
        if (newService) {
          this.modalData = {
            priceOverride: newService.priceOverride || null,
            enabled: newService.enabled,
          };
        }
      },
      immediate: true,
    },
  },
  methods: {
    async saveServiceOverride() {
      this.isSaving = true;
      try {
        const serviceData = {
          id: this.selectedService._id,
          priceOverride: this.modalData.priceOverride,
          enabled: this.modalData.enabled,
        };

        if (!this.modalData.priceOverride && this.selectedService.hasOverride) {
          await medicalServicesOverrideService.delete(
            this.selectedService.overrideId
          );
        } else {
          await medicalServicesOverrideService.createOrUpdate(this.doctor._id, [
            serviceData,
          ]);
        }

        this.$emit("saved");
        this.closeModal();
      } catch (error) {
        console.error("Error al guardar override:", error);
      } finally {
        this.isSaving = false;
      }
    },

    closeModal() {
      this.$emit("close");
    },

    resetForm() {
      this.modalData = {
        priceOverride: null,
        enabled: true,
      };
    },
  },
};
</script>

<template lang="pug">
el-dialog(
  :visible.sync="showDialog"
  :title="selectedService && selectedService.hasOverride ? 'Editar Prestación' : 'Configurar Prestación'"
  width="500px"
  :before-close="closeModal"
  @close="resetForm"
)
  .el-dialog__body
    .form-group
      label.label Prestación:
      p {{ selectedService?.name }}
      p.service-description(v-if="selectedService?.description") {{ selectedService.description }}
    
    .form-group
      label.label Precio Override:
      el-input(
        v-model="modalData.priceOverride"
        type="number"
        step="0.01"
        min="0"
        placeholder="Precio personalizado"
      )
    
    .form-group
      label.label Estado:
      el-checkbox(v-model="modalData.enabled")
        | Prestación activa
  
  .el-dialog__footer
    .footer-buttons
      el-button.button(type="info" @click="closeModal") Cancelar
      el-button.button(type="primary" :loading="isSaving" @click="saveServiceOverride") Guardar
</template>

<style lang="scss" scoped>
.el-dialog__body {
  padding-top: 0;
  padding-bottom: 0;
}

.form-group {
  margin-bottom: 1.5rem;

  .label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
    color: #333;
  }

  .service-description {
    margin: 0;
    color: #666;
    font-size: 0.9rem;
  }
}

.el-dialog__footer {
  display: flex;
  justify-content: flex-end;

  .footer-buttons {
    display: flex;
    gap: 1rem;

    .button {
      border-radius: 5px;
    }
  }
}
</style>
